/* eslint-disable max-lines-per-function */
/* eslint-disable functional/no-conditional-statement */
/* eslint-disable functional/prefer-readonly-type */
import { SetterOrUpdater } from "recoil";
import { mkHcRequestError } from "../../common-fetch/miscellaneous/mkHcRequestError";
import {
  AsyncLoader,
  FinishReturn,
} from "../../common-loader/hooks/useAsyncLoader";
import { CountriesState } from "./countriesAtom";
import { countriesWithTranslations } from "./countriesWithTranslations";
import { fetchGetCountries } from "./fetchGetCountries";
import { fetchGetSettings } from "./fetchGetSettings";
import { initSignIn } from "./initSignIn";
import { CartAndOrder, OrderState } from "./orderAtom";
import { requestOrder } from "./requestOrder";
import { setColors } from "./setColors";
import { SettingsState } from "./settingsAtom";
import { LookupPricingState } from "./lookupPricingAtom";
import { getProductPricingLookup } from "./getProductPricingLookup";
import { setHeaderPosition } from "./setHeaderPosition";
import { translationSetup } from "./translationSetup";
import { translationsFailedToLoad } from "./translationsFromPhrases";
import { languageRequestParam } from "./languageRequestParam";
import { fetchGetPhrases } from "./fetchGetPhrases";
import { definitions } from "../../common-fetch/generated/orders-model-api";
import { setCountryStates } from "../../address/miscellaneous/setCountryStates";

export function buildSetResult(
  loader: AsyncLoader<null>,
  order: OrderState,
  setOrder: SetterOrUpdater<OrderState>,
  setSettings: SetterOrUpdater<SettingsState>,
  setCountryList: SetterOrUpdater<CountriesState>,
  setLookupPricing: SetterOrUpdater<LookupPricingState>,
  setIsPhrasesAPIError: SetterOrUpdater<boolean>,
  setCountryAdministrativeAreas: SetterOrUpdater<
    ReadonlyArray<definitions["IsoCountryResponse"]>
  >
) {
  return async function setResult(): Promise<FinishReturn> {
    const finishLoading = loader.beginLoading();

    const { languageId, country } = await languageRequestParam();
    const phrasesResult = await fetchGetPhrases(languageId, country);

    if (phrasesResult.tag === "successful") {
      await translationSetup(phrasesResult.parsed);
      setIsPhrasesAPIError(false);
    } else {
      const translationsLoadFailed = {
        [translationsFailedToLoad]: "Translations Failed to Load",
      };

      await translationSetup(translationsLoadFailed);
      setIsPhrasesAPIError(true);

      return finishLoading({ tag: "data", data: null });
    }

    const settingsResult = await fetchGetSettings();

    if (
      settingsResult.tag === "successful" &&
      !!settingsResult?.parsed?.authTypes
    ) {
      const settings = settingsResult.parsed as SettingsState;
      const idpAdditional = settingsResult.parsed.idpAdditionalScope ?? "";

      setSettings(settings);
      setColors(settings);
      setHeaderPosition(settings);

      localStorage.setItem("idpAdditionalScope", idpAdditional);
      await initSignIn();

      const [orderResult, countriesResult] = await Promise.all([
        requestOrder(order),
        fetchGetCountries(),
      ]);

      if (
        orderResult.tag === "successful" &&
        countriesResult.tag === "successful"
      ) {
        setOrder(orderResult.order);
        const pricing = await getProductPricingLookup(
          orderResult.order as CartAndOrder
        );
        setLookupPricing(pricing);

        const countries = countriesWithTranslations(countriesResult.parsed);
        setCountryList(countries);
        setCountryStates(
          orderResult.order,
          setCountryAdministrativeAreas,
          finishLoading
        );

        return finishLoading({ tag: "data", data: null });
      }
    }

    return finishLoading({
      tag: "errors",
      errors: [mkHcRequestError],
      uuid: "2d96c4a3-c5d1-407d-a91a-5e8510ce85e5",
    });
  };
}
